//@flow
import { createSelector } from "reselect";

import createI18n, { type I18n } from "@quantum/i18n";

import { type State } from "../../state";

export const chavesI18n = (state: State): * => state.i18n;

export const i18n: (state: State) => I18n<any> = createSelector(
  chavesI18n,
  createI18n
);
